export const PRIORITY_ENUM = {
  EMERGENCY: 'EMERGENCY',
  VERY_URGENT: 'VERY_URGENT',
  URGENT: 'URGENT',
  NOT_VERY_URGENT: 'NOT_VERY_URGENT',
  NOT_URGENT: 'NOT_URGENT'
}
